import _objectSpread from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.own-keys.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createVNode as _createVNode, isRef as _isRef } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "btns"
};
var _hoisted_2 = {
  key: 1
};
import { EditForm } from '@/component-create/EditForm';
import { EventName } from '@/component-create/FormDialog';
import { createIconNode } from '@/component-create/utils/common';

import { ref, toRefs, nextTick } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XFormDialog',
  props: {
    title: {
      type: String,
      default: ''
    },
    footers: {
      type: Array
    },
    form: {
      type: Object,
      required: true
    },
    width: {
      type: String,
      default: '40%'
    },
    getInstance: Function,
    handler: Object
  },
  emits: ['saveSuccess', 'saveFail', 'loadSuccess', 'loadFail', 'opend'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var confireLoading = ref(false);
    var prop = __props;
    var emit = __emit;
    var editFormRef = ref();
    var form = null;
    var _toRefs = toRefs(prop),
      title = _toRefs.title,
      footers = _toRefs.footers,
      getInstance = _toRefs.getInstance;
    var visible = ref(false);
    var instance = new Proxy({}, {});
    var defaultValue = ref({});
    var customSaveParams = ref({});
    var loading = ref(false);
    /**
     * 暴露属性方法
     */
    if (getInstance !== null && getInstance !== void 0 && getInstance.value) {
      getInstance.value(instance);
    }
    instance.open = open;
    instance.close = close;
    instance.showLoading = showLoading;
    instance.closeLoading = closeLoading;
    instance.setSaveParams = function (data) {
      customSaveParams.value = data;
    };
    /**
     * 打开对话框
     * @param data
     */
    function open(data) {
      confireLoading.value = false;
      return new Promise(function (resolve) {
        visible.value = true;
        if (!form) {
          nextTick(function () {
            renderEditForm(data);
            opened();
            resolve(true);
          });
        } else {
          var _form;
          (_form = form) === null || _form === void 0 || _form.setFormData({});
          setFormValue(data);
          opened();
          resolve(true);
        }
      });
    }
    function opened() {
      if (prop.handler && prop.handler['opend']) {
        prop.handler['opend']();
      } else {
        emit('opend');
      }
    }
    function showLoading() {
      loading.value = true;
    }
    function closeLoading() {
      loading.value = false;
    }
    /**
     * 关闭对话框
     */
    function close() {
      var _form2, _form3;
      (_form2 = form) === null || _form2 === void 0 || _form2.setFormData(defaultValue.value || {});
      (_form3 = form) === null || _form3 === void 0 || (_form3 = _form3.elFormInstance) === null || _form3 === void 0 || _form3.clearValidate();
      visible.value = false;
      confireLoading.value = false;
    }
    /**
     * 取消
     */
    function cancle() {
      close();
    }
    /**
     * 确认
     */
    function save() {
      if (confireLoading.value) {
        return;
      }
      confireLoading.value = true;
      var customSave = prop.handler && prop.handler['customSave'];
      if (customSave) {
        var _form4;
        (_form4 = form) === null || _form4 === void 0 || _form4.getFormData().then(function (res) {
          customSave(res);
          confireLoading.value = false;
        });
      } else {
        var _form5;
        (_form5 = form) === null || _form5 === void 0 || _form5.save(function () {
          close();
          saveSuccessEvent();
          confireLoading.value = false;
        }, function () {
          saveFailEvent();
          confireLoading.value = false;
        }, function () {
          confireLoading.value = false;
        });
      }
    }
    function customButtonClick(e) {
      var _form6;
      (_form6 = form) === null || _form6 === void 0 || _form6.getFormData().then(function (res) {
        e === null || e === void 0 || e(res);
      });
    }
    /**
     * 保存成功事件
     */
    function saveSuccessEvent() {
      if (prop.handler && prop.handler[EventName.SAVE_SUCCESS]) {
        var _form7;
        prop.handler[EventName.SAVE_SUCCESS]((_form7 = form) === null || _form7 === void 0 ? void 0 : _form7.getFormDataNotValidate());
      } else {
        var _form8;
        emit('saveSuccess', (_form8 = form) === null || _form8 === void 0 ? void 0 : _form8.getFormDataNotValidate());
      }
    }
    /**
     * 保存失败事件
     */
    function saveFailEvent() {
      if (prop.handler && prop.handler[EventName.SAVE_FAIL]) {
        prop.handler[EventName.SAVE_FAIL]();
      } else {
        emit('saveFail');
      }
    }
    /**
     * 加载成功事件
     */
    function loadSuccessEvent(data) {
      if (prop.handler && prop.handler[EventName.LOAD_SUCCESS]) {
        prop.handler[EventName.LOAD_SUCCESS](data);
      } else {
        emit('loadSuccess', data);
      }
    }
    /**
     * 加载失败事件
     */
    function loadFailEvent() {
      if (prop.handler && prop.handler[EventName.LOAD_FAIL]) {
        prop.handler[EventName.LOAD_FAIL]();
      } else {
        emit('loadFail');
      }
    }
    /**
     * 创建按钮
     * @param el VNode绘制函数
     */
    function createButton(el) {
      return el(form);
    }
    function renderEditForm(data) {
      form = new EditForm(editFormRef.value, prop.form.items, _objectSpread({
        labelPosition: 'right',
        labelWidth: '80px'
      }, prop.form.elFormProps), prop.form.saveUrl, prop.form.loadUrl, prop.form.loaded, prop.form.saveMethods);
      instance.getFormDataNotValidate = form.getFormDataNotValidate.bind(form);
      instance.setFormData = form.setFormData.bind(form);
      instance.getFormData = form.getFormData.bind(form);
      instance.save = form.save.bind(form);
      instance.updateFormData = form.updateFormData.bind(form);
      instance.hideFormItemByKey = form.hideFormItemByKey.bind(form);
      instance.showFormItemByKey = form.showFormItemByKey.bind(form);
      instance.setSaveParams = form.setSaveParams.bind(form);
      form.setSaveParams(customSaveParams.value);
      Reflect.ownKeys(form.getFormDataNotValidate()).forEach(function (key) {
        var _form9;
        defaultValue.value[key] = (_form9 = form) === null || _form9 === void 0 ? void 0 : _form9.getFormDataNotValidate()[key];
      });
      setFormValue(data);
    }
    function setFormValue(data) {
      if (data && prop.form.loadUrl) {
        var _form10;
        (_form10 = form) === null || _form10 === void 0 || _form10.load(data).then(function (data) {
          loadSuccessEvent(data);
        }).catch(function () {
          loadFailEvent();
        });
      } else if (data) {
        var _form11;
        (_form11 = form) === null || _form11 === void 0 || _form11.updateFormData(data);
      }
    }
    function getFormInstance() {
      return form;
    }
    __expose({
      open: open,
      close: close,
      getFormInstance: getFormInstance,
      showLoading: showLoading,
      closeLoading: closeLoading
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(visible) ? visible.value = $event : null;
        }),
        title: _unref(title),
        width: __props.width,
        onClose: close
      }, {
        footer: _withCtx(function () {
          return [_unref(footers) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(footers), function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["item", {
                'first': index === 0
              }])
            }, [item.el ? (_openBlock(), _createBlock(_resolveDynamicComponent(createButton(item.el)), {
              key: 0
            })) : (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: item.type,
              icon: _unref(createIconNode)(item.icon),
              onClick: function onClick($event) {
                return customButtonClick(item.handler);
              }
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.text), 1)];
              }),
              _: 2
            }, 1032, ["type", "icon", "onClick"]))], 2);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
            onClick: cancle
          }, {
            default: _withCtx(function () {
              return _cache[1] || (_cache[1] = [_createTextVNode("取消")]);
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: save,
            loading: _unref(confireLoading)
          }, {
            default: _withCtx(function () {
              return _cache[2] || (_cache[2] = [_createTextVNode("确认")]);
            }),
            _: 1
          }, 8, ["loading"])]))];
        }),
        default: _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", {
            ref_key: "editFormRef",
            ref: editFormRef
          }, null, 512), [[_directive_loading, _unref(loading)]])];
        }),
        _: 1
      }, 8, ["modelValue", "title", "width"]);
    };
  }
});